import { createContext, useState } from 'react'
import { getStorage, deleteStorage } from '@mkmp/core'

interface AuthContextType {
  isAuthenticated: boolean
  userLogout: () => void
}

const AuthContext = createContext<AuthContextType>(null!)

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!getStorage('token'))

  /**
   * 用户登出
   * @returns
   */
  const userLogout = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        setIsAuthenticated(false)
        deleteStorage('token')
        resolve(true)
      }, 1000)
    })
  }

  return <AuthContext.Provider value={{ isAuthenticated, userLogout }}>{children}</AuthContext.Provider>
}

export { AuthContext, AuthProvider }
